import { MollakIcons } from "./Mollak";

const Icons = {
	...MollakIcons,
};

export default Icons;